









import { Component, Prop, Vue } from 'vue-property-decorator';
import md5 from 'md5';

@Component({
    inheritAttrs: false
})
export default class GravatarImg extends Vue {
	@Prop({ type: String, required: false }) email!: string;
	@Prop({ type: String, required: false, default: '' }) hash!: string;
	@Prop({ type: Number, required: false, default: 80 }) size!: number;
	@Prop({ type: String, required: false, default: 'mm' }) defaultImg!: string;
	@Prop({ type: String, required: false, default: 'g' }) rating!: string;
	@Prop({ type: String, required: false, default: 'Avatar' }) alt!: string;
	@Prop({ type: String, required: false, default: 'https' }) protocol!: string;
	@Prop({ type: String, required: false, default: '' }) image!: string;
	@Prop({ type: Boolean, required: false, default: false }) external!: string;

	get url() {
	    if (this.email || this.hash) {
	        const protocol = this.protocol.slice(-1) === ':' ? this.protocol : `${this.protocol}:`;
	        const emailOrHash = this.hash ? this.hash.toLowerCase() : md5(this.email.trim().toLowerCase());
	        const img = [
	            `${protocol === ':' ? '' : protocol}//www.gravatar.com/avatar/`, emailOrHash,
	            `?s=${this.size}`,
	            `&d=${this.defaultImg}`,
	            `&r=${this.rating}`
	        ];
	        return img.join('');
	    }

	    if (this.external) {
	        return this.image;
	    }

	    return require(`@/assets/images/${this.image}`);
	}

	get style() {
	    return {
	        height: this.size + 'px',
	        width: this.size + 'px'
	    };
	}

	public get listeners() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { load, error, ...listeners } = this.$listeners;
	    return listeners;
	}

	public get attrs() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { src, alt, ...attrs } = this.$attrs;
	    return attrs;
	}

	public onLoad(...args: any) {
	    this.$emit('load', ...args);
	}

	public onError(...args: any) {
	    this.$emit('error', ...args);
	}
}
